/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TicketOrderStatus = {
    Pending: 'Pending',
    Paid: 'Paid',
    Declined: 'Declined',
    Unconfirmed: 'Unconfirmed',
    Released: 'Released',
    Refunded: 'Refunded'
} as const;
export type TicketOrderStatus = typeof TicketOrderStatus[keyof typeof TicketOrderStatus];


export function instanceOfTicketOrderStatus(value: any): boolean {
    for (const key in TicketOrderStatus) {
        if (Object.prototype.hasOwnProperty.call(TicketOrderStatus, key)) {
            if (TicketOrderStatus[key as keyof typeof TicketOrderStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TicketOrderStatusFromJSON(json: any): TicketOrderStatus {
    return TicketOrderStatusFromJSONTyped(json, false);
}

export function TicketOrderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketOrderStatus {
    return json as TicketOrderStatus;
}

export function TicketOrderStatusToJSON(value?: TicketOrderStatus | null): any {
    return value as any;
}

export function TicketOrderStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TicketOrderStatus {
    return value as TicketOrderStatus;
}

